import { render, staticRenderFns } from "./JobIcon.vue?vue&type=template&id=72e61a6c&"
import script from "./JobIcon.vue?vue&type=script&lang=js&"
export * from "./JobIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports